module.exports = __webpack_public_path__ + "static/img/facilities-text-5.26626cad.png";